import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/usuario.css";
import "../../css/table.css";
import Table from "../../components/Table";
import buscar_azul from "../../images/search_azul.png";
import { useParams, useNavigate } from "react-router-dom";
import { WhatsApp } from "@mui/icons-material";
import ModalNuevoUsuario from "../../components/empresa_uno_comp/ModalNuevoUsuario";

import { Preloader } from "../../components/Preloader";
import fotoPerfilDefault from "../../images/user.png";
import { FormControl, InputLabel, Select, MenuItem, Tooltip, IconButton, Alert } from "@mui/material";
import { ApiService } from "../../components/ApiService";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import LupaIcon from "../../svg/lupaIcon";
import { ModalForAll, SelectBranchs } from "../../components";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { ImagenesGlobal } from "../../components/global/ImagenesGlobal";
import { RemoveUsers } from "./RemoveUsers";

export const Users = ({ selectedSucursal, permisos, myRoll, loadImageS }) => {
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false); // Estado para manejar el modal
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState("");
	const [snackbarSeverity, setSnackbarSeverity] = useState("");
	const [roles, setRoles] = useState([]);
	const [cargos, setCargos] = useState([]);

	const [userSelected, setUserSelected] = useState({});

	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


	useEffect(() => {
		fetchUsers();
		fetchRolesAndCargos();
	}, [selectedSucursal]);

	const fetchUsers = async () => {
		setLoading(true);
		try {
			const url = `api/company/user/list?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al cargar usuarios");
			}

			setData(response);
			setFilteredData(response);
		} catch (error) {
			//TODO add error emssage
		} finally {
			setLoading(false);
		}
	};

	const fetchRolesAndCargos = async () => {
		try {
			const url = `api/company/list-rc?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al cargar roles y cargos");
			}

			setRoles(response.userRoles);
			setCargos(response.jobTitles);
		} catch (error) { }
	};

	const formatDate = (dateString) => {
		const options = { day: "2-digit", month: "2-digit", year: "numeric" };
		return new Date(dateString).toLocaleDateString("es-ES", options);
	};

	const handleView = (row) => {
		console.log("Ver usuario deshabilitado temporalmente...");
		// console.log("Ver usuario:", row);
	};
	const habilitarUsuario = async (row) => {
		const url = `api/company/user/view?key_branch=${selectedSucursal}&key_user=${row.key_user}`;
		const options = { method: "PUT" };
		const response = await ApiService.fetchData(url, options);
		if (response.code === 200) {
			setFilteredData((prevData) =>
				prevData.map((item) => (item.key_user === row.key_user ? { ...item, status: row.selected } : item))
			);
			setSnackbarMessage(response.message);
			setSnackbarSeverity("success");
			setSnackbarOpen(true);
			return;
		}
		setSnackbarMessage("Error al habilitar el producto");
		setSnackbarSeverity("error");
		setSnackbarOpen(true);
	};

	const columns = [
		{
			name: "N°",
			selector: (row, index) => index + 1,
			sortable: true,
		},
		{
			name: "Foto",
			cell: (row) => (
				<div>
					<ImagenesGlobal url={row?.profile ?? null} type="profile" loadImageS={loadImageS} style={{
						width: "70px",
						height: "80px",
						paddingTop: "5px",
						paddingBottom: "5px",
						borderRadius: "50%",
						objectFit: "cover",
					}} />
				</div>
			),
			sortable: false,
		},
		{
			name: "Nombre Completo",
			selector: (row) => row.fullName,
			sortable: true,
		},
		{
			name: "Fecha de nac.",
			selector: (row) => formatDate(row.birthday),
			sortable: true,
		},
		{
			name: "Teléfono",
			cell: (row) => (
				<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<span>{row.phone}</span>
					<a
						href={`https://wa.me/${row.phoneCode}${row.phone}`}
						target="_blank"
						rel="noopener noreferrer"
						style={{
							backgroundColor: "#25D366",
							borderRadius: "50%",
							width: "24px",
							height: "24px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							textDecoration: "none",
						}}>
						<WhatsApp style={{ color: "white", fontSize: "16px" }} />
					</a>
				</div>
			),
			sortable: false,
		},
		{
			name: "Cargo",
			selector: (row) => row.jobTitle,
			sortable: true,
		},
		{
			name: "Acción",
			cell: (row) => (
				permisos?.edit && (
					<>
						<IconButton>
							{row.selected ? (
								<Tooltip title={"Deshabilitar vista"}>
									<VisibilityOffRoundedIcon
										onClick={(event) => {
											event.stopPropagation();
											habilitarUsuario(row);
										}}
										fontSize={"small"}
										color={"primary"}
									/>
								</Tooltip>
							) : (
								<Tooltip title={"Habilitar vista"}>
									<RemoveRedEyeRoundedIcon
										onClick={(event) => {
											event.stopPropagation();
											habilitarUsuario(row);
										}}
										fontSize={"small"}
										color={"primary"}
									/>
								</Tooltip>
							)}
						</IconButton>

						<button className="default-buttons" style={{ height: 'min-content' }} onClick={() => setUserSelected(row)}>
							<DoDisturbIcon
								fontSize={"small"}
								style={{ color: 'var(--empresa-color)' }}
							/>
						</button>
					</>
				)
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
	];

	const handleViewUser = (obj) => {
		if (!permisos?.edit) return (<></>);

		return (
			<IconButton>
				{obj.selected ? (
					<Tooltip title={"Deshabilitar vista"}>
						<VisibilityOffRoundedIcon
							onClick={(event) => {
								event.stopPropagation();
								habilitarUsuario(obj);
							}}
							fontSize={"small"}
							color={"primary"}
						/>
					</Tooltip>
				) : (
					<Tooltip title={"Habilitar vista"}>
						<RemoveRedEyeRoundedIcon
							onClick={(event) => {
								event.stopPropagation();
								habilitarUsuario(obj);
							}}
							fontSize={"small"}
							color={"primary"}
						/>
					</Tooltip>
				)}
			</IconButton>
		);
	}

	function search_function(e) {
		const text_input = String(e.target.value).trim();

		const filtered = data.filter(
			(cliente) =>
				cliente.fullName.toLowerCase().includes(text_input.toLowerCase()) || cliente.phone.includes(text_input)
		);

		setFilteredData(filtered);
	}

	function deleteUserList(key = null) {
		if (typeof key == 'string') {
			setData((current_list) => (current_list.filter(obj => obj?.key_user != key)));
			setFilteredData((current_list) => (current_list.filter(obj => obj?.key_user != key)));
		}
		setUserSelected({});
	}

	return (
		<>
			<Box>
				<Snackbar
					open={snackbarOpen}
					autoHideDuration={2500}
					onClose={() => {
						setIsModalOpen(false);
						setSnackbarSeverity("");
						setSnackbarMessage("");
					}}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
					<Alert severity={snackbarSeverity} variant={"filled"} sx={{ width: "100%" }}>
						{snackbarMessage}
					</Alert>
				</Snackbar>
				<div className="functionality-container">
					<div>
						<h2 style={{ color: 'var(--theme-company)' }}>Usuarios</h2>
					</div>

					<div style={{ position: "relative", top: "8px" }}>
						<FormControl size="small" sx={{ mb: 2, minWidth: 120, maxWidth: 200 }}>
							<SelectBranchs />
						</FormControl>
					</div>

					<SearchCompany theme={'var(--theme-company)'} setValor={search_function} placeholder="Usuarios" />

					{permisos?.insert && (
						<div className="content-btn-add">
							<button
								className="btn-add-var"
								onClick={() => setIsModalOpen(true)} // Abre el modal
							>
								<span className="txt-add">Nuevo Usuario</span>
							</button>
						</div>
					)}
				</div>

				<div className="datatable-container">
					{loading ? <Preloader /> : (
						currentSize > 480 ? (
							<div className="table-view-pc">
								<Table columns={columns} data={filteredData && filteredData} keyField="key_user"/>
							</div>
						) : (
							<TablesMobile loadImageS={loadImageS} itsCompany={false} filteredData={(filteredData ?? []).map(obj => ({
								img: obj?.profile,
								title: obj?.fullName,
								texto: obj?.jobTitle,
								fullPhone: obj?.codePhone + obj?.phone,
								authCode: obj,
							}))} profile={true} type={'profile'} functionEspecial={handleViewUser} />
						)
					)}
				</div>

				{
					isModalOpen && (
						<ModalNuevoUsuario
							isOpen={isModalOpen}
							onClose={() => setIsModalOpen(false)}
							onUserAdded={fetchUsers}
							current_branch={selectedSucursal}
							roles={roles}
							cargos={cargos}
							keyBranch={selectedSucursal}
						/>
					)
				}
			</Box >

			<RemoveUsers dataUser={userSelected} closeModal={deleteUserList} current_branch={selectedSucursal} />
		</>
	);
};
